export { default } from 'features/cart/routes/cart-extras-route';
